<template>
  <div>
    <el-card v-if="dataForm.clockInId">
      <div class="title">
        {{this.clockInInfo.name}}
        &nbsp;&nbsp;&nbsp;
        <span
          v-if="this.clockInInfo.status == 1"
        >已启用</span>
        <span v-else-if="this.clockInInfo.status == 2">已停用</span>
        <span v-else-if="this.clockInInfo.status == 3">已结束</span>
        <span v-else-if="this.clockInInfo.status == 4">待审核</span>
        
        <el-button v-if="this.clockInInfo.status == 4" type="danger" size="small" @click="addOrUpdateHandle(dataForm.clockInId)" plain>修改</el-button>
        <el-button v-else type="success" size="small" @click="addOrUpdateHandle(dataForm.clockInId)" plain>活动细则</el-button>
      </div>
      <br />
      <div class="time">
        <span>{{this.clockInInfo.startTime}}</span>
        &nbsp;至&nbsp;
        <span>{{this.clockInInfo.endTime}}</span>
      </div>
      <div class="data_list">
        <ul>
          <li>
            <div>{{this.clockInInfo.participateInSum}}</div>
            <span>参与用户数</span>
          </li>
        </ul>
      </div>
    </el-card>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="参与用户" name="first">
        <el-card shadow="never" class="aui-card--fill">
          <div class="mod-demo__clockinuser}">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
              <el-form-item label="用户/账号">
                <el-input v-model="dataForm.accountName" placeholder="请输入用户姓名/账号" clearable></el-input>
              </el-form-item>
              <el-form-item label="开户时间">
                <el-date-picker
                  v-model="dataForm.openStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日"
                ></el-date-picker>&nbsp;至&nbsp;
                <el-date-picker
                  v-model="dataForm.openEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="dataForm.activationStatus" placeholder="全部" clearable>
                  <el-option label="已激活" value="1"></el-option>
                  <el-option label="未激活" value="2"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="激活时间">
                <el-date-picker
                  v-model="dataForm.activationStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日"
                ></el-date-picker>&nbsp;至&nbsp;
                <el-date-picker
                  v-model="dataForm.activationEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label="参与时间">
                <el-date-picker
                  v-model="dataForm.participateStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日"
                ></el-date-picker>&nbsp;至&nbsp;
                <el-date-picker
                  v-model="dataForm.participateEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
              <el-form-item label="总签到次数大于">
                <el-input v-model="dataForm.clockInCount" placeholder="请输入次数" clearable></el-input>
              </el-form-item>
                <el-button @click="queryDataList()">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="info"
                  @click="exportHandle('打卡活动参与用户')"
                >导出</el-button>
              </el-form-item>
            </el-form>
            <el-table
              v-loading="dataListLoading"
              :data="dataList"
              border
              @selection-change="dataListSelectionChangeHandle"
              style="width: 100%;"
            >
              <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
              <el-table-column fixed type="index" label="序号" :index="indexMethod" width="80"></el-table-column>
              <el-table-column prop="account" label="账号" header-align="center" align="center"></el-table-column>
              <el-table-column prop="accountName" label="用户" header-align="center" align="center"></el-table-column>
              <el-table-column
                prop="openAccountTime"
                label="真实开户时间"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="activationStatus"
                label="激活状态"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.activationStatus === 1" size="small" type="success">已激活</el-tag>
                  <el-tag
                    v-else-if="scope.row.activationStatus === 2"
                    size="small"
                    type="warning"
                  >未激活</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="activationTime"
                label="激活时间"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column 
                prop="clockInId" 
                label="活动ID" 
                header-align="center" 
                align="center"
              ></el-table-column>
              <el-table-column 
                prop="clockInName" 
                label="活动名称" 
                header-align="center" 
                align="center"
              ></el-table-column>
              <el-table-column
                  prop="clockInCount"
                  label="总签到次数"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                prop="participateInTime"
                label="参与时间"
                header-align="center"
                align="center"
              ></el-table-column>
            </el-table>
            <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle"
            ></el-pagination>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="打卡记录" name="second">
        <clockin-Recode :clockInId="dataForm.clockInId"></clockin-Recode>
      </el-tab-pane>
    </el-tabs>
    <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" 
      @refreshDataList="getDataList"
      :productList="productList"

      ></add-or-update>
  </div>
</template>

<script>
import mixinViewModule from "./import/view-module";
import AddOrUpdate from "./clockin-add-or-update";
import clockinRecode from "./clockinrecord";
import Url from '@/views/crs/util/url'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: Url.clockIn.user.page,
        getDataListIsPage: true,
        deleteURL: Url.clockIn.base+"/activity/clockInUser",
        deleteIsBatch: true,
        exportURL: Url.clockIn.user.export
      },
      currentPage: 1,
      pageSize:10,
      totalSize: 0,
      dataForm: {
        clockInId: "",
        accountName: "",
        openStartTime: "",
        openEndTime: "",
        activationStatus: "",
        activationStartTime: "",
        activationEndTime: "",
        participateStartTime: "",
        participateEndTime: ""
      },
      clockInInfo: {
        name: "",
        status: "",
        startTime: "",
        endTime: "",
        participateInSum: 0
      },
      activeName: "first",
    };
  },
  components: {
    clockinRecode,
    AddOrUpdate
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    indexMethod(index) {
      return ++index;
    },
    loadDetail(id) {
      //活动面板信息初始化
      this.$axios
        .get(`${Url.clockIn.user.getClockInInfo}?clockInId=` + id)
        .then(res => {
          this.clockInInfo = {
            ...this.clockInInfo,
            ...res.data
          };
        });
    },
     handleSizeChange(val) {
      this.pageSize = val;
      this.getTabData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTabData();
    },
  },
  created() {
    this.dataForm.clockInId = this.$route.query.id;
    this.loadDetail(this.dataForm.clockInId);
    this.queryDataList();
  },
  watch: {
    $route(to, from) {
      window.location.reload()
      if (to.query.id != from.query.id) {
        this.dataForm.clockInId = to.query.id;
        this.loadDetail(this.dataForm.clockInId);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  span {
    border-radius: 8px;
    background: #0096dc;
    text-align: center;
    padding: 5px;
    color: #fff;
    font-size: 12px;
  }
}
.time {
  font-size: 14px;
  color: #999;
}
.data_list {
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    li {
      text-align: center;
      div {
        font-size: 26px;
        color: #333;
      }
      span {
        font-size: 14px;
        color: #999;
      }
    }
  }
}
ul,
li {
  list-style: none;
}
</style>
